import Vue from "vue";
import VueRouter from "vue-router";
import authRoutes from "@/modules/auth/routes";
import settingsRoutes from "@/modules/settings/routes";
import bookingsRoutes from "@/modules/bookings/routes";
import eventRoutes from "@/modules/events/routes";
import paymentsRoutes from "@/modules/payments/routes";
import wizardsRoutes from "@/modules/wizards/routes.js";
import feedbackRoutes from "@/modules/feedback/routes.js";
import upgradeAccountRoutes from "@/modules/upgradeAccount/routes";
import clientPortalEditorRoutes from "@/modules/clientPortalEditor/routes";
import mattersRoutes from "@/modules/matters/routes";
import reportsRoutes from "@/modules/reports/routes";
import marketingRoutes from "@/modules/marketing/routes";
import productOrderRoutes from "@/modules/productOrder/routes";
import itemizableRoutes from "@/modules/itemizable/routes";
import appMarketRoutes from "@/modules/appMarket/routes.js";
import addonsPurchasedRoutes from "@/modules/addonsPurchased/routes";
import noteRoutes from "@/modules/note/routes";
import docuformRoutes from "@/modules/docuform/routes";
import docuformsRoutes from "@/modules/docuforms/routes";
import zoomRoutes from "@/modules/zoom/routes";
import calendarRoutes from "@/modules/scheduler/routes";
import generalAvailabilityRoutes from "@/modules/availability/routes";
import fileUploaderRoutes from "@/modules/filesUploader/routes";
import viewSignatureRoutes from "@/modules/viewSignature/routes";
import upgradePopupRoutes from "@/modules/common/components/UpgradePopUp/routes";
import infectedFileRoutes from "@/modules/infectedFile/routes";
import shareDialogRoutes from "@/modules/shareDialog/routes";
import inboxRoutes from "@/modules/inbox/routes";
import galleryRoutes from "@/modules/gallery/routes";
import notificationsRoutes from "@/modules/notificationCenter/routes";
import notificationSettingsRoutes from "@/modules/notificationSettings/routes";
import newCampaignPreferenceRouts from "@/modules/newCampaignPreference/routes";
import marketingUpgradeRoutes from "@/modules/marketingUpgrade/routes";
import callerIdRoutes from "@/modules/callerId/routes";
import clientPackageHistoryRoutes from "@/modules/clientPackageHistory/routes";
import unsavedChangesRoutes from "@/modules/unsavedChangesDialog/routes";
import ThirdPartyCookiesRoutes from "@/modules/ThirdPartyCookies/routes";
import workOrderUpgradeDialogRoutes from "@/modules/workOrderUpgradeDialog/routes";
import copyLinkRoutes from "@/modules/copyLink/routes";
import accountRoutes from "@/modules/account/routes";
import Pending from "./Pending.vue";
import saleRoutes from "@/modules/sale/routes";
import store from "@/store/store";

Vue.use(VueRouter);

const appRoutes = [
  ...authRoutes,
  ...settingsRoutes,
  ...clientPortalEditorRoutes,
  ...upgradeAccountRoutes,
  ...marketingRoutes,
  ...wizardsRoutes,
  ...feedbackRoutes,
  ...mattersRoutes,
  ...bookingsRoutes,
  ...eventRoutes,
  ...productOrderRoutes,
  ...itemizableRoutes,
  ...reportsRoutes,
  ...paymentsRoutes,
  ...appMarketRoutes,
  ...addonsPurchasedRoutes,
  ...noteRoutes,
  ...docuformRoutes,
  ...docuformsRoutes,
  ...zoomRoutes,
  ...calendarRoutes,
  ...generalAvailabilityRoutes,
  ...fileUploaderRoutes,
  ...viewSignatureRoutes,
  ...upgradePopupRoutes,
  ...infectedFileRoutes,
  ...shareDialogRoutes,
  ...inboxRoutes,
  ...galleryRoutes,
  ...notificationsRoutes,
  ...notificationSettingsRoutes,
  ...newCampaignPreferenceRouts,
  ...marketingUpgradeRoutes,
  ...callerIdRoutes,
  ...clientPackageHistoryRoutes,
  ...unsavedChangesRoutes,
  ...workOrderUpgradeDialogRoutes,
  ...ThirdPartyCookiesRoutes,
  ...copyLinkRoutes,
  ...saleRoutes,
  ...accountRoutes,
  {
    path: "/pending",
    component: Pending,
    meta: {
      skipBusinessLoaded: true
    }
  },
  {
    path: "*",
    redirect: { name: "login" }
  }
];

export const routes = appRoutes;

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {

  const isPane = to.query.PaneView === '1' || to.query.pane === 'true'
  store.commit('setPane', isPane)

  if (to.meta.skipBusinessLoaded) {
    next()
    return
  }

  if (store.getters['accountModule/account']) {
    next()
    return
  }

  store.commit('setLoaderState', true)
  store
    .dispatch('accountModule/fetchAccount')
    .then(() => {
      next()
      store.commit('setLoaderState', false)
    })
})

export default router;
